var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManagedEquipment({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Managed_Equipment_"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Managed_Equipment_",
    "data-name": "Managed Equipment ",
    clipPath: "url(#clip-Managed_Equipment_)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7590",
    "data-name": "Rectangle 7590",
    width: 27,
    height: 26.995,
    rx: 6,
    transform: "translate(0.5 0.502)",
    fill: "#8ec750"
  }), /*#__PURE__*/React.createElement("g", {
    id: "manager",
    transform: "translate(-18.792 -17.444)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19036",
    "data-name": "Path 19036",
    d: "M26.731,140.626a.637.637,0,0,1-.439-.684c.007-1.782,0-3.564,0-5.346a3.23,3.23,0,0,1,1.767-3.059,9.213,9.213,0,0,1,1.647-.571.511.511,0,0,1,.6.381c.21.563.414,1.128.62,1.692q.335.92.669,1.84c.021.059.046.116.09.225.053-.362.1-.672.142-.983.053-.372.11-.743.152-1.117a.5.5,0,0,0-.052-.274c-.161-.3-.34-.591-.508-.888a.559.559,0,0,1,.519-.892c.417,0,.833-.006,1.25,0a.556.556,0,0,1,.511.885c-.173.307-.354.61-.526.917a.31.31,0,0,0-.05.176c.1.7.2,1.407.313,2.161.042-.105.069-.166.091-.228l1.252-3.434a.575.575,0,0,1,.835-.414,8.921,8.921,0,0,1,1.431.513,3.255,3.255,0,0,1,1.781,3.07c.006,1.782,0,3.564,0,5.346a.637.637,0,0,1-.439.684Zm8.946-8.434L33,139.513h4.721c0-.049.008-.088.008-.128,0-1.62.007-3.24-.006-4.86a2.6,2.6,0,0,0-.146-.83A2.34,2.34,0,0,0,35.677,132.191ZM27.4,139.514h4.721l-2.685-7.356a7.228,7.228,0,0,0-.9.364A2.213,2.213,0,0,0,27.4,134.58c0,1.585,0,3.17,0,4.755C27.394,139.392,27.4,139.448,27.4,139.514Z",
    transform: "translate(0 -99.907)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19037",
    "data-name": "Path 19037",
    d: "M67.956,29.757a3.405,3.405,0,1,1,3.4-3.4A3.406,3.406,0,0,1,67.956,29.757Zm2.3-3.38a2.306,2.306,0,1,0-2.329,2.287A2.3,2.3,0,0,0,70.26,26.377Z",
    transform: "translate(-35.391)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19038",
    "data-name": "Path 19038",
    d: "M118.551,147.567a2.34,2.34,0,0,1,1.9,1.5,2.6,2.6,0,0,1,.146.83c.013,1.62.007,3.24.006,4.86,0,.039,0,.078-.008.128h-4.721Z",
    transform: "translate(-82.874 -115.282)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19039",
    "data-name": "Path 19039",
    d: "M41,154.48c0-.066-.008-.122-.008-.178,0-1.585,0-3.17,0-4.755a2.213,2.213,0,0,1,1.145-2.059,7.23,7.23,0,0,1,.9-.364l2.685,7.356Z",
    transform: "translate(-13.593 -114.873)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19040",
    "data-name": "Path 19040",
    d: "M83.828,39.994a2.306,2.306,0,1,1-2.265-2.327A2.314,2.314,0,0,1,83.828,39.994Z",
    transform: "translate(-48.959 -13.617)",
    fill: "#fff",
    opacity: 0.3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagedEquipment);
export default __webpack_public_path__ + "static/media/Managed Equipment.47faf23f2ae174560a3ad40b5b3a34fd.svg";
export { ForwardRef as ReactComponent };